import { PrintConfirmationDialog, PrintConfirmationDialogWrapperProps } from './PrintConfirmationDialog';
import { useIptorTranslation } from '@iptor/base';

export const PickListConfirmation = ({
  open,
  handleClose,
  selectedRows,
  onSuccess,
}: PrintConfirmationDialogWrapperProps) => {
  const { t } = useIptorTranslation();
  return (
    <PrintConfirmationDialog
      open={open}
      handleClose={handleClose}
      title={t('sales_orders:PickListConfirmation')}
      selectedRows={selectedRows || []}
      documentType={'picklist'}
      onSuccess={onSuccess}
    />
  );
};
